import { heroImage, phone, phoneHref } from '../data';

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Traditional Indian silk saree in deep burgundy with antique gold border"
          className="hero-zoom h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-background-50" />
      </div>

      {/* Content */}
      <div className="relative mx-auto flex w-full min-h-[600px] md:min-h-[660px] flex-col items-center justify-center px-4 md:px-6 py-24 text-center">
        <p className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-background-100/90">
          <span className="h-px w-8 bg-background-100/60" aria-hidden="true" />
          Indian Textile Heritage, Brought Closer to Home
          <span className="h-px w-8 bg-background-100/60" aria-hidden="true" />
        </p>

        <h1 className="mt-6 max-w-4xl font-heading text-4xl md:text-6xl leading-[1.08] font-medium text-background-50">
          Timeless Indian Textiles,
          <br className="hidden sm:block" /> Made for Every Occasion.
        </h1>

        <p className="mt-6 max-w-2xl text-[15px] md:text-base leading-relaxed text-background-100/90">
          Discover traditional sarees, dhotis, shirts and Indian ethnic wear, bringing the
          richness of Indian textile culture closer to customers across the UK.
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
          <a
            href="#collections"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-background-50 px-7 py-3.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-background-200"
          >
            Explore Our Collection
          </a>
          <a
            href={phoneHref}
            className="inline-flex items-center justify-center whitespace-nowrap gap-2 rounded-md border border-background-100/50 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
          >
            <i className="ri-phone-line" aria-hidden="true" />
            Contact SRM Textiles
          </a>
        </div>

        <p className="mt-8 text-[12px] tracking-wide text-background-100/70">
          Serving customers across the UK • Call {phone}
        </p>
      </div>
    </section>
  );
}